import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-[100svh] max-h-[100svh] md:min-h-[600px] md:max-h-none flex flex-col justify-center items-center bg-[#0f4c5c] text-white overflow-hidden py-4 md:py-12 px-4" data-id="element-43">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-44"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 h-full" data-id="element-45">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex-1 text-center md:text-left flex flex-col justify-center max-w-lg" data-id="element-46">
          <h1 className="text-[22px] leading-[1.15] sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-4 text-white drop-shadow-sm" data-id="element-47">
            ESTÁS PERDIENDO DINERO EN TU CONSULTORIO… Y PROBABLEMENTE NO LO
            SABÉS
          </h1>
          <p className="text-[15px] leading-snug sm:text-lg md:text-xl text-slate-200 mb-4 md:mb-8 font-sans" data-id="element-48">
            Trabajás, atendés pacientes, tu agenda se llena… pero no sabés
            cuánto ganás realmente ni por qué cada mes es distinto.
          </p>

          <div className="hidden md:flex flex-col items-start" data-id="element-49">
            <button onClick={scrollToCompra} className="bg-[#d4a017] hover:bg-[#c29215] text-white font-bold py-4 px-8 rounded-full text-lg transition-transform hover:scale-105 shadow-lg w-full md:w-auto" data-id="element-50">
              👉 ACCEDER AL KIT CONSULTORIO PRO
            </button>
            <p className="mt-3 text-sm text-slate-300 font-medium" data-id="element-51">
              $19.900 ARS · Acceso inmediato
            </p>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex-1 w-full max-w-[280px] sm:max-w-[320px] md:max-w-md flex justify-center items-center" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/nPWuMVTAHJYkN13gPQ6gmY/3.png" alt="Kit Consultorio Pro Mockup" className="w-full h-auto object-contain drop-shadow-2xl cursor-pointer hover:scale-105 transition-transform" onClick={scrollToCompra} data-id="element-53" />
        </motion.div>

        {/* Mobile CTA (Visible only on mobile, placed at bottom of hero) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="w-full md:hidden flex flex-col items-center mt-2" data-id="element-54">
          <button onClick={scrollToCompra} className="bg-[#d4a017] hover:bg-[#c29215] text-white font-bold py-3.5 px-6 rounded-full text-[16px] transition-transform active:scale-95 shadow-lg w-full max-w-sm" data-id="element-55">
            👉 ACCEDER AL KIT CONSULTORIO PRO
          </button>
          <p className="mt-2 text-[13px] text-slate-300 font-medium" data-id="element-56">
            $19.900 ARS · Acceso inmediato
          </p>
        </motion.div>
      </div>
    </section>;
}